import { useRef, useEffect, useState } from "react";
import { data, Link } from "react-router-dom";
import { useSession } from "../components/SessionProvider";
import Deadline from "../components/Deadline";
import ConfirmDialog from "../components/ui/ConfirmDialog";
//import { EmailEditor } from "../components/ui/EmailEditor";
import Button from "../components/ui/Button";
import DownloadLink from "../components/ui/DownloadLink";
import { useApi } from "../hooks/useApi";
import { parseISO, format } from 'date-fns';
// import SearchField from "../components/SearchField";
const SitesList = () => {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const isDevelopment = import.meta.env.VITE_APP_ENV === 'development';
  const { siteFilters, setSiteFilters } = useSession();
  const [siteUserData, setSiteUserData] = useState([]);
  const [currentSiteId, setCurrentSiteId] = useState(false);
  const {
    filterSubmitted,
    filterActive,
    filterCompleted,
    filterEmptyAddress,
    filterNoUsersAssigned,
    filterEmptyGateNumber,
    filterHasPST,
    filterIsOld,
    filterHasBudgetLines
  } = siteFilters;

  const mainSiteUrl = import.meta.env.VITE_MAIN_SITE_URL;
  const initialized = useRef(false);
  const [emailData, setEmailData] = useState([]);
  const { apiCall } = useApi();
  const { userLogin } = useSession();
  const [inProgress, setInProgress] = useState(false);
  const [uncodedCount, setUnCodedCount] = useState(false);
  const [copySuccess, setCopySuccess] = useState('');
  const [summarydialogopen, setSummarydialogopen] = useState(false);
  const [summarydialogMessage, setSummarydialogMessage] = useState('');
  const [summaryinProgress, setSummaryinProgress] = useState(false);
  const intervalRef = useRef(null);
  const [downloadFileLink, setDownloadFileLink] = useState('');
  const [zipFileLink, setZipFileLink] = useState('');
  const [xlsxLink, setXlsxLink] = useState('');

  const handleFilterChange = (filterName, value) => {
    // Update state based on filter name
    setSiteFilters(prev => ({
      ...prev,
      [filterName]: value
    }));


  };
  const showUsers = (siteID) => {
    // Update state based on filter name
    apiCall(`fetch_site_users`, { params: { site_id: siteID } })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch project users");
        }
        return response.json();
      })
      .then((data) => {
        setSiteUserData(data);
        setDialogOpen(true);
      })
      .catch((err) => {
        alert(err.message);
      });

  };
  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      apiCall(`fetch_sites`, { params: { user_email: userLogin.user_email, is_admin: userLogin.isAdmin ? 1 : 0 } }) // Update with your actual API endpoint
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch sites");
          }
          return response.json();
        })
        .then((data) => {
          if (data.error) {
            setError(data.error);
            setLoading(false);
          }
          const sitesWithCleanAddress = data.map(site => ({
            ...site,
            clean_address: [site.site_address, site.site_city, site.site_province, site.site_postal_code]
              .filter(Boolean)
              .join(', ')
          }));
          //const uncodedCount_temp = data.filter(site => site.active_coding_sheet_count > 0).length;
          //setUnCodedCount(uncodedCount_temp);
          setSites(sitesWithCleanAddress);
          setLoading(false);
        })
        .catch((err) => {
          setError(err.message);
          setLoading(false);
        });

      apiCall(`getEntireCodingSheetUncodedCount`) // Update with your actual API endpoint
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to fetch sites");
          }
          return response.json();
        }).then((data) => {
          setUnCodedCount(data.count);
        });
    }



  }, []);




  if (loading) return <p>Loading sites...</p>;
  if (error) return <p>Error: {error}</p>;




  if (!sites.length) {
    return <p className="m-5 text-center">You don't have any sites assigned to you.</p>

  }
  const highlightText = (text, query) => {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, "gi");
    return text.replace(regex, '<span class="bg-yellow-300">$1</span>');
  };

  const filteredSites = sites.filter((site) =>
    site.site_name.toLowerCase().includes(searchTerm.toLowerCase().trim()) ||
    site.site_number.toString().includes(searchTerm.trim())
  ).filter((site) =>
    filterSubmitted ? site.invoice_done : true
  ).filter((site) =>
    filterActive ? site.active_coding_sheet_count > 0 : true
  ).filter((site) =>
    filterEmptyGateNumber ? !site.gate_number : true
  ).filter((site) =>
    filterEmptyAddress ? !site.site_address : true
  ).filter((site) =>
    filterCompleted ? site.completed == 1 : true
  ).filter((site) =>
    filterNoUsersAssigned ? !site.assigned_users_count : true
  ).filter((site) =>
    filterHasPST ? site.has_pst : true
  ).filter((site) =>
    filterIsOld ? site.is_4_months_old : true
  ).filter((site) =>
    filterHasBudgetLines ? site.has_budget_lines : true
  );
  const copyToClipboard = async (emailAddresses) => {
    const emailString = emailAddresses.join(',');
    try {
      await navigator.clipboard.writeText(emailString);
      setCopySuccess('Copied!');
      setTimeout(() => setCopySuccess(''), 2000);
    } catch (err) {
      setCopySuccess('Failed to copy!');
      setTimeout(() => setCopySuccess(''), 2000);
      console.error('Failed to copy: ', err);
    }
  };
  const handleSummaryCancel = () => {
    if (downloadFileLink) {
      //if download link exists, on close, remove it
      // apiCall(`removeSummaryFiles`, { method: 'POST' }).then((res) => setSummarydialogopen(false));
      setSummarydialogopen(false)
      setDownloadFileLink('');
      setZipFileLink('');
      setXlsxLink('');

    }
    else {
      setSummarydialogopen(false);
    }

  };
  const startTimer = () => {
    if (intervalRef.current !== null) {
      return; // Already running
    }
    intervalRef.current = setInterval(() => {
      apiCall(`checkSummaryFileStatus`, { method: 'POST' }).then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setSummarydialogMessage(data.message);
            if (data.download_file) {
              stopTimer();
              setDownloadFileLink(data.download_file);
              setZipFileLink(data.zip_file);
              setXlsxLink(data.xlsx_file);
              setSummaryinProgress(false);

            }
          }
        });
    }, 4000);
  };

  const stopTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null; // Reset the ref
    }
  };
  const generateSummaryInvoiceRequest = async (e) => {

    e.preventDefault();
    setSummarydialogopen(true);
    if (summaryinProgress || downloadFileLink) return;
    setSummaryinProgress(true);


    const response = await apiCall(`requestSummaryFileGeneration`, { method: 'POST' });
    const data = await response.json();
    if (data.success) {
      if (data.message) {
        setSummarydialogMessage(data.message);
      }
      startTimer();
    } else {
      stopTimer();
      if (data.error) {
        setSummarydialogMessage(data.error);
      }
      else {
        setSummarydialogMessage('Unexpected error occurred.');
      }

    }




  };


  const sendEmail = () => {

    if (!currentSiteId) {
      alert('No project id');
      return;
    }
    if (!emailData.subject) {
      alert('No subject defined');
      return;
    }
    if (inProgress) return;
    setInProgress(true);


    apiCall(`sendCustomEmailToSitesUsingCustomBody`, {
      method: "POST",
      body: {
        site_ids: [currentSiteId],
        subject: emailData.subject,
        message: emailData.message
      },
    }).then((res) => res.json())
      .then((data) => {
        if (data.success) {
          if (data.message) {
            alert(data.message);
          }
          closeDialog();
        } else {

          if (data.error) {
            alert(data.error);
          }
          else {
            alert("Error setting up the reminder.");
          }

        }

      }).finally((data) => {
        setInProgress(false);

      });

  };
  const handleEmailChange = (field, value) => {
    setEmailData(prev => ({
      ...prev,
      [field]: value
    }));
  };
  const closeDialog = () => {
    setDialogOpen(false);
    setCurrentSiteId(false);
  };
  const DataTable = ({ data }) => {

    if (!data || data.length === 0 || !currentSiteId) return <p>No data available</p>;

    const columns = {
      user_email: 'Email',
      emails_enabled: 'Emails Enabled',
      all_site_access: 'All Site Access',
      phone: 'Phone'
    };
    const emailAddresses = data.filter(user =>
      user.emails_enabled == 1
    ).map(user => user.user_email);

    const current_site = sites.find(site => site.id == currentSiteId);

    return (
      <div className="max-h-[60vh] overflow-auto  border-gray-300 rounded overscroll-contain">
        <div>Project: <strong>{current_site.site_name}</strong></div>
        <div>Project# <strong>{current_site.site_number}</strong></div>
        {emailAddresses.length > 0 && (
          <>
            <button onClick={(e) => { copyToClipboard(emailAddresses) }} className="btn btn-primary">Copy all the "Emails Enabled" email addresses.</button>
            <span className="ml-4">{copySuccess}</span>
          </>

        )}
        <table className="min-w-full border border-gray-300 divide-y divide-gray-300">
          <thead className="bg-gray-100">
            <tr>
              {Object.entries(columns).map(([key, displayName]) => (
                <th key={key} className="px-4 py-2 text-left text-sm font-semibold text-gray-700">
                  {displayName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.map((item, index) => (
              <tr key={index} className="hover:bg-gray-50">
                {Object.keys(columns).map((key) => (
                  <td key={key} className="px-4 py-2 text-sm text-gray-600">
                    {item[key] == 0 ? 'No' : (item[key] == '1' ? <span className="text-blue-500">Yes</span> : item[key])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {/*       <div className="mt-6">
          <p><i>Note: Emails will only be sent to those that have emails enabled in the list above.</i></p>

          <div className="space-y-4 mt-3">
            <div><strong>Subject:</strong></div>
            <input
              name="subject"
              type="text"
              placeholder="Add Subject"
              value={emailData.subject}
              onChange={(e) => handleEmailChange('subject', e.target.value)}
              className="border p-2 rounded w-full"
              required
            />
            <div><strong>Body:</strong></div>
            <EmailEditor
              value={emailData.message}
              onChange={(html) => handleEmailChange('message', html)}
            />

          </div>
        </div> */}
      </div>
    );
  };
  return (

    <div className="p-6">
      {summarydialogopen && (
        <ConfirmDialog
          msgstyle={{ whiteSpace: 'pre-line' }}
          open={summarydialogopen}
          title="Request to Combine Summary Invoices"
          message={(
            <>
              {summarydialogMessage}
              {downloadFileLink && zipFileLink && xlsxLink && (
                <>
                  <div><DownloadLink link={downloadFileLink}>Download Combined Invoices (PDF)</DownloadLink></div>
                  <div><DownloadLink link={xlsxLink}>Download Combined Invoices (XLS)</DownloadLink></div>
                  <div><DownloadLink link={zipFileLink}>Download Individual Invoices (ZIP)</DownloadLink></div>
                </>

              )
              }
            </>


          )}
          cancelText={"Close"}
          inProgress={summaryinProgress}
          onCancel={handleSummaryCancel}
          hideConfirm
        />
      )}
      {siteUserData && currentSiteId && (
        <>

          <ConfirmDialog
            width="700px"
            open={dialogOpen}
            title="Project Users"
            message={DataTable({ data: siteUserData })}
            cancelText="Close"
            inProgress={inProgress}
            hideConfirm
            /*  confirmText="Send Email"
             onConfirm={sendEmail} */
            onCancel={closeDialog}
          />
        </>

      )

      }


      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Projects List</h1>
        <Deadline />
        {userLogin.isAdmin && (

          <Link to="/add-project" className="btn btn-primary">
            Add New Project
          </Link>

        )}

      </div>
      <div className="flex justify-between items-end">
        <div>
          <label className="flex w-fit mb-4">
            <input
              type="checkbox"
              checked={filterSubmitted}
              onChange={(e) => handleFilterChange('filterSubmitted', e.target.checked)}

              className="mr-2"
            />
            Coding Submitted
          </label>
          <label className="flex w-fit items-center mb-4">
            <input
              type="checkbox"
              checked={filterActive}
              onChange={(e) => handleFilterChange('filterActive', e.target.checked)}
              className="mr-2"
            />
            Uncoded
          </label>
          {userLogin.isAdmin && (
            <>
              <label className="flex w-fit items-center mb-4">
                <input
                  type="checkbox"
                  checked={filterEmptyGateNumber}
                  onChange={(e) => handleFilterChange('filterEmptyGateNumber', e.target.checked)}
                  className="mr-2"
                />
                Empty Gate Three Sub-PO #
              </label>
              <label className="flex w-fit items-center mb-4">
                <input
                  type="checkbox"
                  checked={filterHasPST}
                  onChange={(e) => handleFilterChange('filterHasPST', e.target.checked)}
                  className="mr-2"
                />
                Has PST
              </label>
              <label className="flex w-fit items-center mb-4">
                <input
                  type="checkbox"
                  checked={filterHasBudgetLines}
                  onChange={(e) => handleFilterChange('filterHasBudgetLines', e.target.checked)}
                  className="mr-2"
                />
                Has Budget Lines
              </label>
            </>
          )}
        </div>
        { /* && (uncodedCount === 0 || isDevelopment) */}
        {(userLogin.isAdmin && (uncodedCount === 0 || isDevelopment)) && (
          <div>
            <div className="flex justify-center">
              <Button onClick={generateSummaryInvoiceRequest} >Download Combined Summary Invoices</Button>
            </div>
            {isDevelopment && (
              <span className="mb-3 block">In development, You can download despite uncoded sheets but the results will be inconsistent</span>
            )}
          </div>


        )}
        {userLogin.isAdmin && (
          <div>
            <label className="flex w-fit items-center mb-4">
              <input
                type="checkbox"
                checked={filterCompleted}
                onChange={(e) => handleFilterChange('filterCompleted', e.target.checked)}
                className="mr-2"
              />
              Completed Projects
            </label>
            <label className="flex w-fit items-center mb-4">
              <input
                type="checkbox"
                checked={filterEmptyAddress}
                onChange={(e) => handleFilterChange('filterEmptyAddress', e.target.checked)}
                className="mr-2"
              />
              Address Missing
            </label>
            <label className="flex w-fit items-center mb-4">
              <input
                type="checkbox"
                checked={filterNoUsersAssigned}
                onChange={(e) => handleFilterChange('filterNoUsersAssigned', e.target.checked)}
                className="mr-2"
              />
              No Users Assigned
            </label>
            <label className="flex w-fit items-center mb-4">
              <input
                type="checkbox"
                checked={filterIsOld}
                onChange={(e) => handleFilterChange('filterIsOld', e.target.checked)}
                className="mr-2"
              />
              No Invoices (4 Months)
            </label>
          </div>


        )
        }


      </div>

      <div>
        <input
          type="text"
          placeholder="Search by site name or ID..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="border p-2 rounded w-full mb-4"
        />

      </div>
      <table className="w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2" width="140">Project #</th>
            <th className="border p-2">Project Name</th>
            {userLogin.isAdmin && (
              <th className="border p-2" style={{ minWidth: "100px" }}>Sub-PO #</th>
            )}
            <th className="border p-2">Project Address</th>
            {userLogin.isAdmin && (
              <th className="border p-2" width="110">User Count</th>
            )}

            <th className="border p-2">Status</th>
            {userLogin.isAdmin && (
              <th className="border p-2" width="120">Date Created</th>
            )}
          </tr>
        </thead>
        <tbody>
          {filteredSites.map((site) => (
            <tr key={site.id} className="border">
              <td className="border p-2">
                <div className="flex items-center justify-between">
                  <div dangerouslySetInnerHTML={{ __html: highlightText(site.site_number, searchTerm) }}></div>
                  {userLogin.isAdmin && (
                    <Link to={`/edit-project/${site.id}`} className="text-blue-600 hover:underline">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                      </svg>
                    </Link>
                  )}
                </div>



              </td>
              <td className="border p-2 uppercase" >
                <Link to={`/projects/${site.id}`} className="text-blue-600 hover:underline" dangerouslySetInnerHTML={{ __html: highlightText(site.site_name, searchTerm) }} />

              </td>
              {userLogin.isAdmin && (
                <td className="border p-2 text-center">{(site.gate_number)}</td>
              )}
              <td className="border p-2">{site.clean_address}</td>

              {userLogin.isAdmin && (
                <td className="border p-2 text-center">
                  {site.assigned_users_count && (
                    <span className="cursor-pointer p-1 inline-block min-w-[20px] border-b-1 border-b-gray-700 hover:bg-gray-400 hover:text-white" onClick={(e) => { e.preventDefault(); showUsers(site.id); setCurrentSiteId(site.id) }}>{(site.assigned_users_count)}</span>
                  )}

                </td>
              )}

              <td className="border p-2 text-center">
                <span className={`p-1 rounded ${site.completed == 1 ? "bg-gray-100 text-gray-800" : "bg-blue-50 text-blue-800"}`}>
                  {site.completed == 1 ? "Completed" : "Active"}
                </span>
              </td>
              {userLogin.isAdmin && (
                <td className="border p-2 text-center">
                  {format(parseISO(site.date_created), 'MMM-yyyy')}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SitesList;